import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
// import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import Footer from "../../core/common/Footer";
import { PageBreadcrumb } from "../../core/common/BreadCrumbForm";

const StoreUpload = () => {
  //   handle download Excel
  const handleDownloadTemplate = () => {
    const link = document.createElement("a");

    link.href = "/assets/files/Applicants_Template.xlsx";
    link.download = "template.xlsx";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // breadcrumb data
  const breadcrumbItem = [
    { label: "Track Case Program", path: all_routes.trackCase },
    { label: "Case Detailss" },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* PageBreadcrumb */}
        {/* <PageBreadcrumb
          title="Upload Store"
          // breadcrumbs={breadcrumbItem}
          showBackButton={true}
          backRoute={all_routes.trackCase}
        /> */}
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Store Upload</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.superAdminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item active">Store Upload</li>
              </ol>
            </nav>
          </div>
          {/* <div className="head-icons ms-2">
            <CollapseHeader />
          </div> */}
        </div>
        {/* Table  */}
        <div className="card border-0 shadow-sm mt-3">
          <div className="card-body p-4">
            <div className="text-center">
              <i
                className="ti ti-upload text-primary"
                style={{ fontSize: "50px" }}
              ></i>

              <h5 className="mt-3 mb-2">Upload Excel File</h5>

              <p className="text-muted mb-3">
                Upload your Excel sheet or download the template first.
              </p>

              <div className="d-flex justify-content-center gap-2 mb-3">
                <button
                  className="btn btn-outline-primary"
                  onClick={handleDownloadTemplate}
                >
                  <i className="ti ti-download me-1"></i>
                  Download Template
                </button>

                <label className="btn btn-primary mb-0">
                  <i className="ti ti-upload me-1"></i>
                  Choose File
                  <input type="file" hidden accept=".xlsx,.xls" />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default StoreUpload;
